import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const FadeInWrapper = styled.div`
    opacity: 0;
    animation: ${fadeIn} 0.5s ease-in forwards;
    will-change: opacity;
`;

export const TransitionRoot = styled.div`
    position: relative;
`;

export const IntroLayer = styled.div<{ isOverlay: boolean }>`
    position: ${({ isOverlay }) => (isOverlay ? "absolute" : "static")};
    inset: ${({ isOverlay }) => (isOverlay ? "0" : "auto")};
    width: 100%;
    z-index: ${({ isOverlay }) => (isOverlay ? 2 : "auto")};
    pointer-events: ${({ isOverlay }) => (isOverlay ? "none" : "auto")};
`;
